import React, { useRef, useState } from 'react'
import { Column } from 'primereact/column'
import FormList from 'base/FormList'
import VariavelService from 'business/cadastro/outros/variavel/variavelService'

export default function VariavelList() {

    const [service] = useState(() => new VariavelService())
    const toast = useRef(null)

    const searchData = {
        pkName: 'codigo_var',
        dsName: 'descricao_var',
        mainField: { name: 'descricao_var', label: 'Descrição' },
        advFields: [
            { name: 'codigo_var', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_var', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'nome_var', label: 'Nome', type: 'string', inputMode: 'text' },
            { name: 'cod_gruv_var', label: 'Grupo', type: 'integer', inputMode: 'numeric' },
        ]
    }

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_var" sortable header="Código"></Column>
            <Column field="descricao_var" sortable header="Descrição"></Column>
            <Column field="nome_var" sortable header="Nome"></Column>
            <Column field="descricao_grupo" sortable header="Grupo"></Column>
        </FormList>
    )
}
